import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminTeasersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('teaser');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
